import React from "react";
import { RecIcon } from "../materials/MaterialRecordParts";
import { FAVORITE_PACKAGE } from "../../helpers/projectFavorites";
import "./projects.css";

/**
 * Offline state of a FAVORITE project, one language for the Projects hub and
 * the Project page:
 *   ready      – small, muted ("Ready offline")
 *   preparing  – small, muted, temporary
 *   attention  – a real failure: highlighted and actionable (Retry). Never
 *                shown as Ready.
 * Returns null when there is nothing to say.
 */
export function ProjectOfflineBadge({ state, onRetry, block = false }) {
  if (state === FAVORITE_PACKAGE.ATTENTION) {
    return (
      <div
        className={`pj-offline pj-offline--attention${block ? " pj-offline--block" : ""}`}
        data-testid="project-favorite-state"
        role="status"
      >
        <span>Offline copy needs a refresh</span>
        {onRetry ? (
          <button
            type="button"
            data-testid="project-favorite-retry"
            onClick={(event) => {
              event.stopPropagation();
              onRetry();
            }}
          >
            Retry
          </button>
        ) : null}
      </div>
    );
  }
  if (state === FAVORITE_PACKAGE.READY) {
    return (
      <span className="pj-offline pj-offline--ready" data-testid="project-favorite-state">
        <RecIcon name="cloud" />
        Ready offline
      </span>
    );
  }
  if (state === FAVORITE_PACKAGE.PREPARING) {
    return (
      <span className="pj-offline pj-offline--preparing" data-testid="project-favorite-state">
        <RecIcon name="cloud" />
        Preparing offline…
      </span>
    );
  }
  return null;
}
